import { useBaseApiQuery } from "@query/baseQuery";

export const useSitesQuery = (club_uuid) => {
    return useBaseApiQuery({ endpoint: `/club/${club_uuid}/site/all` }, { queryKey: ["sites"], enabled: typeof club_uuid === 'string' });
};